import { Form, Input, Select } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Component from '../../../../shared/components';
import { getPlaylistAddHandlers } from '../handlers/playlistAddHandler';

const PlaylistAdd: React.FC = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [isLoading] = useState<boolean>(false);

  const { handleAddClick } = getPlaylistAddHandlers({ form, navigate });

  return (
    <>
      {isLoading ? (
        <Component.LoadingSpinnerComponent />
      ) : (
        <Component.BasePageComponent>
          <div>
            <div className="playlist-details-page">
              <Form form={form} layout="vertical" className="playlist-details-form">
                <Form.Item name="title" label="Title">
                  <Input />
                </Form.Item>
                <Form.Item name="description" label="Description">
                  <Input />
                </Form.Item>
                <Form.Item name="type" label="Type" rules={[{ required: true }]}>
                  <Select
                    options={[
                      { value: 'manual', label: 'manual' },
                      { value: 'dynamic', label: 'dynamic' },
                      { value: 'bebridge', label: 'bebridge' },
                    ]}
                  />
                </Form.Item>
                <Form.Item name="created" label="Created">
                  <Input readOnly />
                </Form.Item>
              </Form>
            </div>
            <div className="playlist-detail-update-button" style={{ marginTop: '30px' }}>
              <Component.ColorButtonComponent text="Add" onClick={() => handleAddClick()} />
            </div>
          </div>
        </Component.BasePageComponent>
      )}
    </>
  );
};

export default PlaylistAdd;
